import { SocialModel } from '../models';

export const CENTER_SOCIAL_LINKS: Array<SocialModel> = [
  {
    name: 'facebook',
    href: 'https://www.facebook.com/centerhealthapp?utm_source=site_footer',
  },
  {
    name: 'instagram',
    href: 'https://www.instagram.com/centerhealth_?utm_source=site_footer',
  }
  // {
  //   name: 'twitter',
  //   href: 'https://twitter.com/centerhealth_?utm_source=site_footer',
  // },
  // {
  //   name: 'snapchat',
  //   href: 'https://www.snapchat.com/add/centerhealth?utm_source=site_footer',
  // },
];

export default CENTER_SOCIAL_LINKS;
